module.exports = __webpack_public_path__ + "img/lk.f94b7c7d.png";